import styled from "styled-components";

const FooterWrapper = styled.div``;

export { FooterWrapper };
